export default __webpack_public_path__ + "static/media/pexels-jill-burrow-6858667.49aa182f.jpg";